import actions from './actions'

export default function ContractTextsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_CONTRACTTEXT:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_CONTRACTTEXT:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_CONTRACTTEXT:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_CONTRACTTEXT:
      return {
        ...state,
        editing: { contractTextID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_CONTRACTTEXT_RECIEVED ||
      actions.UPDATE_CONTRACTTEXT_RECIEVED ||
      actions.DELETE_CONTRACTTEXT_RECIEVED:
      return {
        ...state,
        editing: { contractTextID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
